import { Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import Analytics from "./pages/Analytics";
import Sessions from "./pages/Sessions";
import Customers from "./pages/Customers";
import Priests from "./pages/Priests";
import PatashalaStudents from "./pages/PatashalaStudents";
import Payments from "./pages/Payments";
import PujaCatalog from "./pages/PujaCatalog";
import Content from "./pages/Content";
import SearchGrowth from "./pages/SearchGrowth";
import LocationPages from "./pages/LocationPages";
import Configuration from "./pages/Configuration";

export default function AdminApp() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Overview />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="sessions" element={<Sessions />} />
            <Route path="customers" element={<Customers />} />
            <Route path="priests" element={<Priests />} />
            <Route path="patashala" element={<PatashalaStudents />} />
            <Route path="payments" element={<Payments />} />
            <Route path="puja-catalog" element={<PujaCatalog />} />
            <Route path="content" element={<Content />} />
            <Route path="search-growth" element={<SearchGrowth />} />
            <Route path="location-pages" element={<LocationPages />} />
            <Route path="configuration" element={<Configuration />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}
